let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iCMN4")).then(() => parcelRequire('jWgLY'));